import { Checkbox01 } from 'shared/ui/Checkbox';

// 추후 수정
export const AccompanimentToggle = ({ accompaniment, setAccompaniment }) => {
  // 토글로 변경 후 수정 예정
  return (
    <>
      <div className='caregiver-question'>
        <div className='title'>
          <span>병원에 보호자분과 함께 오셨나요?</span>
        </div>

        <div className='caregiver-info-options'>
          <div
            className={`caregiver-info-option ${accompaniment === 'Y' ? 'option-selected' : ''}`}
            onClick={() => setAccompaniment('Y')}
          >
            <span className='text'>네, 함께 왔어요.</span>
            <Checkbox01 checked={accompaniment === 'Y'} />
          </div>

          <div
            className={`caregiver-info-option ${accompaniment === 'N' ? 'option-selected' : ''}`}
            onClick={() => setAccompaniment('N')}
          >
            <span className='text'>아니요, 함께 오지 않았어요.</span>
            <Checkbox01 checked={accompaniment === 'N'} />
          </div>
        </div>
      </div>
    </>
  );
};
